<template>
  <div class="header">
    <div class="box">
      <div class="logo">
        <h3>广州市金界电子有限公司</h3>
      </div>
      <div class="menu">
        <ul>
          <li>
            <a href>首页</a>
          </li>
          <li>
            <a href>关于金界</a>
          </li>
          <li>
            <a href>系统方案</a>
          </li>
          <li>
            <a href>产品中心</a>
          </li>
          <li>
            <a href>合作伙伴</a>
          </li>
          <li>
            <a href>联系我们</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header {
  width: 100%;
  height: 48px;
  background-color: rgb(0, 152, 239);
}
.box {
  width: 1000px;
  height: 48px;
  margin: 0 auto;
}
.logo {
  width: 250px;
  height: 48px;
  line-height: 48px;
  color: #fff;
  font-weight: 400;
  float: left;
}
.menu {
  width: 750px;
  height: 48px;
  margin-left: 250px;
  /* border: 1px solid yellow; */
  display: table;
}
.menu ul {
  display: table-cell;
  vertical-align: middle;
}
.menu ul li {
  display: inline-block;
}
.menu ul li a {
  color: #fff;
  padding: 8px 22px;
}
</style>
<script>
export default {
  name: "header"
};
</script>





// WEBPACK FOOTER //
// src/components/nwenav.vue